import { render, staticRenderFns } from "./CurePlansTable.vue?vue&type=template&id=c9f1686a&"
import script from "./CurePlansTable.vue?vue&type=script&lang=js&"
export * from "./CurePlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports